export * from './analysis.service'
import { AnalysisAPIService } from './analysis.service'
export * from './auth.service'
import { AuthAPIService } from './auth.service'
export * from './cache.service'
import { CacheAPIService } from './cache.service'
export * from './calendarEvents.service'
import { CalendarEventsAPIService } from './calendarEvents.service'
export * from './categories.service'
import { CategoriesAPIService } from './categories.service'
export * from './customers.service'
import { CustomersAPIService } from './customers.service'
export * from './dashboard.service'
import { DashboardAPIService } from './dashboard.service'
export * from './extractionMethods.service'
import { ExtractionMethodsAPIService } from './extractionMethods.service'
export * from './orders.service'
import { OrdersAPIService } from './orders.service'
export * from './reports.service'
import { ReportsAPIService } from './reports.service'
export * from './samples.service'
import { SamplesAPIService } from './samples.service'
export * from './samplingOrders.service'
import { SamplingOrdersAPIService } from './samplingOrders.service'
export * from './surveys.service'
import { SurveysAPIService } from './surveys.service'
export const APIS = [
    AnalysisAPIService,
    AuthAPIService,
    CacheAPIService,
    CalendarEventsAPIService,
    CategoriesAPIService,
    CustomersAPIService,
    DashboardAPIService,
    ExtractionMethodsAPIService,
    OrdersAPIService,
    ReportsAPIService,
    SamplesAPIService,
    SamplingOrdersAPIService,
    SurveysAPIService,
]
